<template>
  <div class="app-container" style="padding: 10px">
    <div class="filter-container">
      <el-form :inline="true" label-position="top" label-width="100px">
        <el-form-item label="类型" class="custom-item">
          <el-select v-model="listQuery.amtTypeId" class="filter-item">
            <el-option label="全部" value />
            <el-option
              v-for="(item,index) in amtTypeList"
              :key="index"
              :label="item.amtTypeName"
              :value="item.amtTypeId"
            />
            <el-option label="转账" value="4" />
          </el-select>
        </el-form-item>
        <el-form-item label="变动时间" class="custom-item">
          <el-date-picker
            v-model="bitTime"
            :default-time="['00:00:00','23:59:59']"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
          />
        </el-form-item>
        <el-form-item label="." class="custom-item">
          <el-button
            v-waves
            v-loading.fullscreen.lock="listLoading"
            class="filter-item"
            type="primary"
            icon="el-icon-search"
            @click="handleFilter"
          >{{ $t('table.search') }}</el-button>
        </el-form-item>
        <el-form-item label="." class="custom-item">
          <el-button
            v-waves
            class="filter-item"
            type="info"
            icon="el-icon-document"
            @click="handleAmountToExcel"
          >导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      v-loading="listLoading"
      :key="0"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%;"
    >
      <el-table-column label="流水号" align="center" width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column label="类型" align="center" width="80px">
        <template slot-scope="scope">
          <span>{{ scope.row.amtTypeName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="金额" align="center" width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.amt }}</span>
        </template>
      </el-table-column>
      <el-table-column label="账户余额" align="center" width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.balanceAmt }}</span>
        </template>
      </el-table-column>
      <el-table-column label="时间" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.createdTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作站点" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.optStationName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="备注" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.memo }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.pi"
        :page-sizes="[10,20,30]"
        :page-size="listQuery.ps"
        :total="total"
        background
        layout="total, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import { fetchAmtHistory } from '@/api/record'
import waves from '@/directive/waves' // 水波纹指令
import { getDateOfMonth } from '../../utils'
import { amountRecordToExcel } from '@/api/download'
import { downloadFile } from '@/utils/file'
export default {
  name: 'HistoryAmount',
  directives: {
    waves
  },
  props: {
    companyId: {
      type: Number,
      required: true
    },
    memberId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      tableKey: 0,
      list: [],
      total: null,
      listLoading: true,
      listQuery: {
        pi: 1,
        ps: 20,
        amtTypeId: '',
        beginTime: '',
        endTime: ''
      },
      amtTypeList: [],
      bitTime: getDateOfMonth(1)
    }
  },
  watch: {
    $route () {}
  },
  created () {
    this.amtTypeList = []
    this.amtTypeList.push({ amtTypeId: 1, amtTypeName: '加油' })
    this.amtTypeList.push({ amtTypeId: 2, amtTypeName: '充值' })
    this.amtTypeList.push({ amtTypeId: 3, amtTypeName: '退款' })
    this.getList()
  },
  methods: {
    getList () {
      this.listLoading = true
      this.listQuery['companyId'] = this.companyId
      this.listQuery['memberId'] = this.memberId
      if (this.bitTime) {
        this.listQuery.beginTime = this.bitTime[0]
        this.listQuery.endTime = this.bitTime[1]
      }
      fetchAmtHistory(this.listQuery).then(response => {
        const row = response.data
        if (row.data) {
          this.list = row.data.items
          this.total = row.data.totalItems
        }
        this.listLoading = false
      })
    },
    handleFilter () {
      this.listQuery.pi = 1
      this.getList()
    },
    handleSizeChange (val) {
      this.listQuery.ps = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.listQuery.pi = val
      this.getList()
    },
    handleAmountToExcel () {
      let loadingIns
      this.$confirm('确定导出加油记录为excel吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        loading: true,
        type: 'info'
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          loadingIns = loading
          amountRecordToExcel(this.listQuery)
            .then(response => {
              if (response.data) {
                const type = response.headers['content-type']
                // response.setHeader("Content-Type", "application/vnd.ms-excel"); type必须和后端的type一致
                downloadFile(response, type)
                loadingIns.close()
              }
            })
            .catch(e => {
              this.$message({
                type: 'warning',
                message: '导出失败！ 原因：' + e
              })
              loadingIns.close()
            })
        })
        .catch(() => {
          this.$message({
            type: 'warning',
            message: '取消导出！'
          })
          loadingIns.close()
        })
    }
  }
}
</script>

